import type { GetStaticProps } from 'next'
import type { ComponentProps } from 'react'

import {
  getFeaturedArticles,
  getTopAcademyCategories,
  latestArticlesByCategory,
} from '@/graphql/HealthAcademyCategories'
import { getAcademyHomepageContent } from '@/graphql/HealthAcademyHomepage'

import { AcademyHomePage } from '@/components/pages/learn/AcademyHomePage'

type Props = ComponentProps<typeof AcademyHomePage>

export default AcademyHomePage

export const getStaticProps: GetStaticProps<Props> = async () => {
  const homepage = await getAcademyHomepageContent()
  if (!homepage) return { notFound: true }

  const categories = await getTopAcademyCategories()
  const promiseArray = categories.map((category) => latestArticlesByCategory(category.id))
  const articlesByCategory = await Promise.all(promiseArray).then((values) => values)
  const featuredArticles = await getFeaturedArticles()
  return { props: { homepage, categories, articlesByCategory, featuredArticles } }
}
